export default __webpack_public_path__ + "static/media/330_private03-fr-web.2794e0cc.png";